<template>
  <el-card>
    <el-form ref="form" :model="formData" :rules="rules" label-width="auto">
      <el-form-item :label="$t('名称')" prop="name">
        <el-input :placeholder="$t('请输入名称')" v-model="formData.name" disabled />
      </el-form-item>
      <el-form-item :label="$t('小贴士内容')" prop="content">
        <wangeditor :upload-img-server="$api.file.uploadEditor" v-model="formData.content" ref="editor" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit">{{$t('确认')}}</el-button>
        <el-button @click="resetForm">{{$t('重置')}}</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import Wangeditor from "@/components/Wangeditor";
import {resetEmpty} from "@/utils/common";
import {request} from "@/config/request";
export default {
  name: "RiceTipEdit",
  components: {Wangeditor},
  data() {
    return {
      formData: {
        name: "",
        content: ""
      },

      rules: {
        name: {required: true, message: this.$t('请输入名称'), trigger: 'blur'},
        content: {required: true, message: this.$t('请输入小贴士内容'), trigger: 'blur'}
      },
      detailInfo: {}
    }
  },
  methods: {
    async handleSubmit() {
      try {
        const params = Object.assign(this.detailInfo, this.formData);
        delete params.createTime;
        delete params.updateTime;
        await request(this.$api.riceRwrTips.update, params);
        this.$message.success(this.$t('操作成功'));
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    },

    resetForm() {
      this.$refs.form.resetFields();
      this.$refs.editor.clear();
      resetEmpty(this.formData);
    },

    async loadDetail() {
      try {
        const res = await request(this.$api.riceRwrTips.detail, this.$route.query);
        for (const key in this.formData) {
          this.formData[key] = res.riceRwrTips[key];
        }
        this.detailInfo = res.riceRwrTips;
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>

.el-form {
  width: 800px;
}

</style>
